<div class="col-md-6 col-md-offset-3 p-5">
    <h2 class="mb-4">Yearly plan properties</h2>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <div class="form-group mb-2">
            <label for="created" class="d-block">Creation of subscription</label>
            <mat-form-field class="w-100">
                <input matInput [matDatepicker]="creationDatePicker" formControlName="created" id="created">
                <mat-datepicker-toggle matIconSuffix [for]="creationDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #creationDatePicker></mat-datepicker>
            </mat-form-field>
            @if (created.invalid && (created.dirty || created.touched)) {
                <p class="form-text text-danger">Please provide a valid date</p>
            }
        </div>
        <div class="form-group mb-2">
            <label for="created" class="d-block">Start of subscription</label>
            <mat-form-field class="w-100">
                <input matInput [matDatepicker]="startDatePicker" formControlName="start" id="created">
                <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            @if (start.invalid && (start.dirty || start.touched)) {
                <p class="form-text text-danger">Please provide a valid date</p>
            }
        </div>
        <div class="form-group mb-2">
            <label for="end" class="d-block">End of subscription</label>
            <mat-form-field class="w-100">
                <input matInput [matDatepicker]="endDatePicker" formControlName="end" id="end">
                <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>
            @if (end.invalid && (end.dirty || end.touched)) {
                <p class="form-text text-danger">Please provide a valid date</p>
            }
        </div>
        <div class="form-group mb-2">
            <label for="capacity">Capacity/user count</label>
            <input type="number" class="form-control" id="capacity" formControlName="capacity">
            @if (capacity.invalid && (capacity.dirty || capacity.touched)) {
                <p class="form-text text-danger">Please provide a valid number</p>
            }
        </div>
        <div class="form-group mb-3">
            <label for="quadernoId">Quaderno contact id</label>
            <input class="form-control" id="quadernoId" formControlName="quadernoId" placeholder="12345" type="number">
            @if (quadernoId.invalid && (quadernoId.dirty || quadernoId.touched)) {
                <p class="form-text text-danger">Please provide a valid id (number)</p>
            }
        </div>

        <a type="button" class="btn btn-default me-2" [routerLink]="['/admin/team', team_id]">Cancel</a>
        <button class="btn btn-primary" type="submit" [disabled]="!form.valid">Save</button>
    </form>
</div>
